var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"openAddButton"}},[_c('i',{staticClass:"material-icons",attrs:{"id":"addButton"},on:{"click":_vm.add}},[_vm._v("add")])])}
var staticRenderFns = []

export { render, staticRenderFns }